import React from 'react';
import clsx from 'clsx';
import NavBar from '../components/navbar';
import FirebaseConnector from '../data/FirebaseConnector';
import history from '../components/history';
import { Typography, CircularProgress, Paper, Collapse, IconButton, Button } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StarIcon from '@material-ui/icons/Star';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import '../styles/exerciseview.css';

const errorClass = "exerciseview error";
const loadingClass = "exerciseview loading";
const rootClass = "exerciseview root";
const expandedClass = "exerciseview expanded";
const expandOpenClass = "exerciseview expandopen";
const starConatinerClass = "exerciseview starcontainer";
const titleConatinerClass = "exerciseview titlecontainer";
const rightTitleContainerClass = "exerciseview titlerightcontainer";
const starClass = "exerciseview star";
const selectedPostfix = " selected";

const averageRating = (ratings) => {
    var a = 0;
    var sum = 0;
    for (let i in ratings) {
        a += ratings[i];
        sum++;
    }
    a /= sum;
    return a;
}

class ExerciseView extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            exercise: null,
            exerciseLoaded: false,
            exerciseNotFound: false,
            solutionShown: false,
            selectedStars: -1,
            selfRating: -1,
            moderator: false,
        };
        this.handleExpandClick = this.handleExpandClick.bind(this);
        this.stars = this.stars.bind(this);
    }

    async componentDidMount() {
        if (!this.props.id) {
            history.goBack();
        }
        const db = new FirebaseConnector();
        const e = await db.getExercise(this.props.id);
        if (e !== null && e !== undefined) {
            const user = await db.getUserData();
            var r = -1;
            var mod = false;
            if (user) {
                const roles = await user.getRoles();
                mod = roles.moderator;
                r = e.ratings[user.id];
                if (!r) {
                    r = -1;
                }
            }
            this.setState({
                exercise: e,
                exerciseLoaded: true,
                exerciseNotFound: false,
                selfRating: r,
                selectedStars: r - 1,
                moderator: mod,
            });
        } else {
            this.setState({
                exerciseLoaded: true,
                exerciseNotFound: true,
            });
        }
    }

    handleExpandClick() {
        this.setState({
            solutionShown: !this.state.solutionShown,
        });
    }

    render() {
        if (!this.state.exerciseLoaded) {
            return (
                <>
                    <NavBar />
                    <CircularProgress className={loadingClass} />
                </>
            );
        }
        if (this.state.exerciseNotFound) {
            setTimeout(() => history.push('/'), 5000);
            return (
                <>
                    <NavBar />
                    <div className={errorClass}>
                        <Typography variant="h4">
                            An error occured while loading the page!<br />
                            It seems like the content you are looking for cannot be found.<br />
                            If you clicked on a link and landed here, please contact the webmaster.
                        </Typography>
                        <Typography variant="h6">You will be redirected in 5 seconds.</Typography>
                    </div>
                </>
            );
        }
        const e = this.state.exercise;
        return (
            <>
                <NavBar />
                <Paper className={rootClass}>
                    <div className={titleConatinerClass}>
                        <Typography variant="h6">{e.title}</Typography>
                        <div className={rightTitleContainerClass}>
                            {this.state.moderator && !e.shown && (
                                <Button color="primary" variant="contained" style={{ marginRight: '8px' }} onClick={() => { new FirebaseConnector().moderatorShow(e.id); e.shown = true; this.setState({ exercise: e }); }}>Anzeigen</Button>
                            )}
                            {this.stars(averageRating(e.ratings))}
                        </div>
                    </div>
                    <hr />
                    <Typography variant="body2">{e.problem}</Typography>
                    <hr />
                    <table >
                        <tbody>
                            <tr style={{ verticalAlign: 'top' }}>
                                <td style={{ width: '100%' }}>
                                    <Collapse in={this.state.solutionShown}>
                                        <Typography variant="body2">{e.solution}</Typography>
                                    </Collapse>
                                </td>
                                <td>
                                    <IconButton
                                        className={clsx(expandedClass, {
                                            [expandOpenClass]: this.state.solutionShown,
                                        })}
                                        onClick={this.handleExpandClick}
                                        aria-expanded={this.state.solutionShown}
                                        aria-label="show more"
                                    >
                                        <ExpandMoreIcon />
                                    </IconButton>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Paper>
            </>
        );
    }



    stars(num) {
        num = Math.max(0, Math.min(num, 5));
        num *= 2;
        num = Math.round(num);
        let r = [];
        for (let i = 0; i < 5; i++) {
            if (num >= 2) {
                r.push(<StarIcon key={i} className={starClass + (this.state.selectedStars >= i ? selectedPostfix : '')} onMouseOver={() => this.setState({ selectedStars: i })} onClick={() => this.giveRating(i + 1)} />);
            } else if (num === 1) {
                r.push(<StarHalfIcon key={i} className={starClass + (this.state.selectedStars >= i ? selectedPostfix : '')} onMouseOver={() => this.setState({ selectedStars: i })} onClick={() => this.giveRating(i + 1)} />);
            } else {
                r.push(<StarBorderIcon key={i} className={starClass + (this.state.selectedStars >= i ? selectedPostfix : '')} onMouseOver={() => this.setState({ selectedStars: i })} onClick={() => this.giveRating(i + 1)} />);
            }
            num -= 2;
        }
        return <div className={starConatinerClass} onMouseLeave={() => this.setState({ selectedStars: this.state.selfRating - 1 })}>{r}</div>;
    }

    async giveRating(num) {
        const db = new FirebaseConnector();
        const u = await db.getUserData();
        if (u) {
            db.updateRating(this.state.exercise.id, u.id, num);
            this.setState({ selfRating: num });
        } else {
            history.push('/login');
        }
    }

}

export default ExerciseView;